import { render, staticRenderFns } from "./WorkBookChapterScoreFull.vue?vue&type=template&id=02437a37&scoped=true&"
import script from "./WorkBookChapterScoreFull.vue?vue&type=script&lang=js&"
export * from "./WorkBookChapterScoreFull.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookChapterScoreFull.vue?vue&type=style&index=0&id=02437a37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02437a37",
  null
  
)

export default component.exports